import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { MapPin, ChevronRight, ChevronLeft } from "react-feather";
import useWindowSize from "utils/useWindowSize";
import { useTheme, Typography, Box, Container } from "@mui/material";
import Animated from "components/Animated";
import Image from "next/image";

const Slider = ({ linkData, interval = 3000 }) => {
  const { sizes } = useWindowSize();
  const theme = useTheme();
  const [currentIndex, setCurrentIndex] = useState(0);

  const CustomNextButton = ({ onClick }) => (
    <button
      onClick={onClick}
      className="flex justify-center items-center -mt-10 absolute right-0 top-1/2 w-10 h-20 cursor-pointer transition-colors duration-200 hover:bg-[#243d7f]"
    >
      <ChevronRight color="white" size={28} />
    </button>
  );

  const CustomPrevButton = ({ onClick }) => (
    <button
      onClick={onClick}
      className="flex justify-center items-center -mt-10 absolute left-0 top-1/2 w-10 h-20 cursor-pointer transition-colors duration-200 hover:bg-[#243d7f] z-1"
    >
      <ChevronLeft color="white" size={28} />
    </button>
  );

  return (
    <div
      className="relative"
      style={{
        height: 220,
        marginBottom: 40,
        marginTop: 90,
      }}
    >
      <Carousel
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        infiniteLoop
        autoPlay
        interval={interval}
        className="relative"
        onChange={(index) => setCurrentIndex(index)}
        renderArrowNext={(onClickHandler) => (
          <CustomNextButton onClick={onClickHandler} />
        )}
        renderArrowPrev={(onClickHandler) => (
          <CustomPrevButton onClick={onClickHandler} />
        )}
      >
        {linkData &&
          linkData.length > 0 &&
          linkData.map((item) => (
            <div key={item.id}>
              <div
                style={{
                  position: "relative",
                  height: 220,
                  width: "100%",
                  margin: "0 auto",
                }}
              >
                <Image
                  src={item.image}
                  alt="Banner"
                  fill
                  quality={80}
                  priority
                  style={{
                    objectFit: "cover",
                    objectPosition: "bottom",
                    zIndex: -1,
                  }}
                />
                {/* <Container maxWidth="lg" disableGutters> */}
                  <Box className=" absolute top-[70px]  w-full  flex justify-center items-center">
                    <Box
                      className={`${sizes.sm ? "max-w-[500px]" : "max-w-[900px]"}   flex justify-center `}
                      style={{
                        fontFamily: '"Merriweather", serif',
                        fontStyle: "italic",
                        color: "#fff",
                        fontWeight: 600,
                        textShadow: "0 0 20px #000",
                        fontWeight: 600,
                        lineHeight: 1.4,
                        textAlign: "left",
                      }}
                    >
                      <Typography
                        variant={sizes.sm ? "h30" : "h50"}
                        className="text-white uppercase "
                      >
                        {item.title}
                      </Typography>
                    </Box>
                  </Box>
                {/* </Container> */}
              </div>
            </div>
          ))}
      </Carousel>
    </div>
  );
};

export default Slider;
